import React, { Component, PropTypes } from 'react';
import clientConfig from '../../../configs/client';
import { translate as t } from 'lang';

import './SocialAuthDialog.scss';

class SocialAuthDialog extends Component {

    static propTypes = {
        socialAuthType: PropTypes.string.isRequired,
        onClose: PropTypes.func,
        onSocialComplete: PropTypes.func,
    }

    state = {
        url: '',
    }

    static socialWindowIntervalId = null

    constructor(props) {
        super(props);

        var url = '';
        switch (props.socialAuthType) {
            case 'yandex':
                url = 'https://oauth.yandex.ru/authorize' +
                        '?response_type=token' +
                        '&display=popup' +
                        `&client_id=${clientConfig.social.yandex.client_id}`;
                break;
            case 'google':
                url = 'https://accounts.google.com/o/oauth2/v2/auth' +
                        `?client_id=${clientConfig.social.google.client_id}` +
                        '&response_type=token' +
                        '&scope=email profile' +
                        `&redirect_uri=${clientConfig.social.google.redirect_uri}`;
                break;
            /*case 'facebook':
                url = 'https://www.facebook.com/dialog/oauth' +
                        `?client_id=${clientConfig.social.facebook.client_id}` +
                        '&scope=public_profile,email' +
                        '&response_type=token' +
                        '&display=popup' +
                        `&redirect_uri=${clientConfig.social.facebook.redirect_uri}`;
                break;*/
            case 'mailru':
                url = 'https://connect.mail.ru/oauth/authorize' +
                    `?client_id=${clientConfig.social.mailru.client_id}` +
                    '&response_type=token' +
                    '&display=popup' +
                    `&redirect_uri=${clientConfig.social.mailru.redirect_uri}`;
                break;
            /*case 'ok':
                url = 'https://connect.ok.ru/oauth/authorize' +
                    `?client_id=${clientConfig.social.ok.client_id}` +
                    '&response_type=token' +
                    '&layout=a' +
                    '&scope=GET_EMAIL' +
                    `&redirect_uri=${clientConfig.social.ok.redirect_uri}`;
                break;*/
            /*case 'vk':
                url = 'https://oauth.vk.com/authorize' +
                    `?client_id=${clientConfig.social.vk.client_id}` +
                    '&response_type=token' +
                    '&display=popup' +
                    '&scope=email,offline' +
                    `&redirect_uri=${clientConfig.social.vk.redirect_uri}`;
                break;*/
        }

        window.__onVezetvsemSocialComplete = this._onSocialComplete;

        this.state.url = url;

        var width = 500, height = 400;
        var top = ((window.innerHeight - height) / 2) + window.screenY;
        var left = ((window.innerWidth - width) / 2) + window.screenX;

        this.state.socialWindow = window.open(url, props.socialAuthType, `toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`);
    }
    
    componentWillMount() {
        this.socialWindowIntervalId = setInterval(() => {
            if (this.state.socialWindow && this.state.socialWindow.closed) {
                this._onPopoutClosing();
            }
        }, 300);
    }

    componentWillUnmount() {
        if (this.socialWindowIntervalId) {
            clearInterval(this.socialWindowIntervalId);
        }
    }
    
    _onSocialComplete = (userData) => {

        if (!userData) {
            alert(t('SOCIAL_AUTH_ERROR'));
            return false;
        }

        if (this.props.onSocialComplete) {
            this.props.onSocialComplete(userData, this.props.socialAuthType);
        }

        this._onPopoutClosing();
    }

    _onPopoutClosing = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        return (
            <div className="SocialAuthDialog"/>
        );
    }
}

export default SocialAuthDialog;



// WEBPACK FOOTER //
// ./client/components/SocialAuthDialog/SocialAuthDialog.js